// src/PrivacyPolicy.js
import React from "react";
import { Container, Typography } from "@mui/material";

function PrivacyPolicy2() {
  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom>
        Gizlilik Politikası
      </Typography>
     
      <Typography variant="body1" paragraph>
        Aniword olarak kullanıcılarımızın gizliliğine büyük önem veriyoruz. Aniword hiçbir kişisel veri (isim, e‑posta, konum, cihaz kimliği vb.) toplamaz. Oyun içi ilerleme ve ayarlar, yalnızca cihazınızda yerel önbelleğe (cache) kaydedilir ve başka bir sunucuya gönderilmez.
      </Typography>
      <Typography variant="body1" paragraph>
        Aniword, reklamlar haricinde internet bağlantısına ihtiyaç duymaz ve veri aktarımı yapmaz.
      </Typography>
      <Typography variant="body1" paragraph>
        Üçüncü taraf reklam sağlayıcıları (AdMob, Unity Ads vb.), reklam kimliğinizi (Advertising ID) kullanarak daha alakalı reklamlar sunabilir. Aniword, reklam sağlayıcıların verileri nasıl kullandığı üzerinde kontrol sahibi değildir; lütfen ilgili reklam ağı politikalarını inceleyin.
      </Typography>
      <Typography variant="body1" paragraph>
        Aniword kendi çerez veya izleme teknolojisini kullanmaz. Sadece uygulama önbelleği veri saklama amacıyla kullanılır.
      </Typography>
      <Typography variant="body1" paragraph>
        Aniword, cihazınızdaki verileri yalnızca uygulama silinene kadar önbellekte tutar. Mobil işletim sisteminin sağladığı standart güvenlik önlemleri ile yetkisiz erişim engellenir.
      </Typography>
      <Typography variant="body1" paragraph>
        Aniword, 13 yaş altındaki çocukların kişisel verilerini toplamaz. Ebeveynler, veri silme taleplerini <a href="mailto:support@korsananime.com">support@korsananime.com</a> adresine iletebilir.
      </Typography>
      <Typography variant="body1" paragraph>
        Bu politika zaman zaman güncellenebilir. Önemli değişiklikler uygulama içi duyurular veya bu sayfanın güncellenmesi ile ilan edilir.
      </Typography>
      <Typography variant="body1">
        Gizlilik politikasıyla ilgili sorularınız için bize <a href="mailto:support@korsananime.com">support@korsananime.com</a> adresinden ulaşabilirsiniz.
      </Typography>
    </Container>
  );
}

export default PrivacyPolicy2;
